import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToolbarComponent } from '../../../shared/components/toolbar/toolbar.component';
import { ThemeService } from '../../../shared/services/theme.service';

@Component({
  selector: 'clp-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    ToolbarComponent
  ]
})
export class SettingsComponent implements OnInit {
  private themeService = inject(ThemeService);

  isDarkTheme = true;

  ngOnInit(): void {
    this.isDarkTheme = this.themeService.isDarkTheme();
  }

  onThemeToggle(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.isDarkTheme = checked;
    this.themeService.setTheme(checked ? 'dark' : 'light');
  }
}
